import Container from '@/components/base/Container';
import SectionHeading from '@/components/base/SectionHeading';
import TopicCard from '@/components/base/TopicCard';
import { topics } from '@/mocks/topics';

export default function FeaturedTopics() {
  const featured = [...topics].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <Container>
        <SectionHeading
          eyebrow="Featured"
          title="精选追踪专题"
          desc="每篇专题都是一条完整时间线，从最初线索到最新进展，全部按节点保留。"
          linkText="全部专题"
          linkPath="/tracking"
        />

        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((topic) => (
            <TopicCard key={topic.slug} topic={topic} />
          ))}
        </div>
      </Container>
    </section>
  );
}